/**
 * 获取远程 Api 数据
 * https://docs.google.com/spreadsheets/d/1vYl6z-EYVCQmcPV82J9gf3uCwzsn9CishsBk55EmZF4/edit#gid=1612504060
 * @param {sting} apiName api文件名
 * @param {obj} args 参数
 * @returns {Promise<unknown>}
 * @example get_api_data('apiName',{stage:'phaseSeven-cn'})
 */
import Request from "@/axios/request";
const get_api_data = (
    method = "GET",
    apiName = "libraries-menu",
    args = {}
) => {
    if (method === "GET") {
        return Request.get(apiName, { params: args });
    } else if (method === "POST") {
        return Request.post(apiName, args);
    } else if (method === "PUT") {
        return Request.put(apiName, args);
    } else if (method === "DELETE") {
        return Request.delete(apiName, args);
    } else if (method === "PATCH") {
        return Request.patch(apiName, args);
    }
};

export { get_api_data };
